/**
 * JetBrains Mono is now self-hosted app-wide via @fontsource (see src/index.js),
 * so this component no longer injects a Google Fonts <link>. Kept as a no-op so
 * the gallery pages that render it don't need to change.
 */
export function ArtistsGalleryFontLinks(): JSX.Element | null {
  return null;
}
